import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
    const persistedReducer = persistReducer(
        {
            key:'scap',
            storage,
            whitelist: ['auth', 'user', 'navbar'],
        },
        reducers
    );
    return persistedReducer;
}